import { render, staticRenderFns } from "./EcommerceReport.vue?vue&type=template&id=1faa8448"
import script from "./EcommerceReport.vue?vue&type=script&lang=js"
export * from "./EcommerceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports